// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__u0X8-","item":"PaymentsMobile_item__2D5iA","label":"PaymentsMobile_label__YPW8e","amount":"PaymentsMobile_amount__2rvSm"};